import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rt0011',
    ecrans: ['00-2']
});
